"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var StopScheduleWidget_1 = __importDefault(require("../../../../utils/fabric/Widgets/StopSchedule/StopScheduleWidget"));
var elementStyles_1 = require("./elementStyles");
var StopScheduleElement = function (_a) {
    var object = _a.object;
    return (react_1.default.createElement("div", { key: object.cId, style: (0, elementStyles_1.generateElementContainerStyle)(object) },
        react_1.default.createElement(StopScheduleWidget_1.default, { stopProps: object.cStopProps, id: object.cId })));
};
exports.default = StopScheduleElement;
//# sourceMappingURL=StopScheduleElement.js.map